import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-fortinet',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Fortinet icon</title><path d="M0 9.785h6.788v4.454H0zm8.666-6.33h6.668v4.453H8.666zm0 12.637h6.668v4.454H8.666zm8.522-6.307H24v4.454h-6.812zM2.792 3.455C1.372 3.814.265 5.404 0 7.425v.506h6.788V3.454zM0 16.091v.554c.24 1.926 1.276 3.466 2.624 3.9h4.188v-4.454zm24-8.184v-.506c-.265-1.998-1.372-3.587-2.792-3.972h-4.02v4.454H24zM21.376 20.57c1.324-.458 2.36-1.974 2.624-3.9v-.554h-6.812v4.454Z"/></svg>`,
    styles: []
})
export class SimpleIconsFortinetComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#EE3124';
    @Input() className: string = 'simple-icons-fortinet'
    constructor() {}
    ngOnInit(): void {}
}
